/**
 * A function that transforms a value of type T and returns the same type.
 * Used as a building block for functional composition of CDK constructs.
 */
export type ComposerFn<T> = (input: T) => T

/**
 * Applies a sequence of composer functions to an initial value from left to right.
 */
export const compose = <T>(initialValue: T, ...args: Array<ComposerFn<T>>): T => {
    return args.reduce((acum, current) => {
        return current(acum)
    }, initialValue)
}
